/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getMenu = /* GraphQL */ `
  query GetMenu($name: String!) {
    getMenu(name: $name) {
      id
      name
      icon
      status
      navigateTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMenus = /* GraphQL */ `
  query ListMenus(
    $name: String
    $filter: ModelMenuFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMenus(
      name: $name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        icon
        status
        navigateTo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubMenu = /* GraphQL */ `
  query GetSubMenu($name: String!) {
    getSubMenu(name: $name) {
      id
      name
      icon
      status
      navigateTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubMenus = /* GraphQL */ `
  query ListSubMenus(
    $name: String
    $filter: ModelSubMenuFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSubMenus(
      name: $name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        icon
        status
        navigateTo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBanner = /* GraphQL */ `
  query GetBanner($id: ID!) {
    getBanner(id: $id) {
      id
      image
      tags
      status
      navigateTo
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBanners = /* GraphQL */ `
  query ListBanners(
    $filter: ModelBannerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBanners(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        image
        tags
        status
        navigateTo
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($title: String!) {
    getProductCategory(title: $title) {
      id
      title
      image
      status
      navigateTo
      metaTitle
      metaDescription
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductCategories = /* GraphQL */ `
  query ListProductCategories(
    $title: String
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProductCategories(
      title: $title
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        image
        status
        navigateTo
        metaTitle
        metaDescription
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($slug: String!) {
    getProduct(slug: $slug) {
      id
      title
      slug
      images {
        original
        thumbnail
        __typename
      }
      productIamge
      status
      navigateTo
      category
      description
      dimension {
        name
        size
        details
        value2
        multi1
        multi2
        __typename
      }
      metaTitle
      metaDescription
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $slug: String
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProducts(
      slug: $slug
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        slug
        productIamge
        status
        navigateTo
        category
        description
        metaTitle
        metaDescription
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAddress = /* GraphQL */ `
  query GetAddress($id: ID!) {
    getAddress(id: $id) {
      id
      companyName
      address
      zipCode
      state
      country
      mobileNumber
      phone
      email1
      email2
      socialMedia {
        image
        status
        navigateTo
        __typename
      }
      copyright
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAddresses = /* GraphQL */ `
  query ListAddresses(
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyName
        address
        zipCode
        state
        country
        mobileNumber
        phone
        email1
        email2
        copyright
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
